import { api } from '@/api/core/api';

export const START_AERIAL_RUN_URL = 'aerial/run';

export interface StartAerialRunRequest {
  aerialId: string;
}

export interface StartAerialRunResponse {
  /** `null` when the backend declined to start a run (e.g. one is already in flight). */
  aerialRunId: string | null;
}

const startAerialRunApi = api.injectEndpoints({
  endpoints: (builder) => ({
    startAerialRun: builder.mutation<StartAerialRunResponse, StartAerialRunRequest>({
      query: ({ aerialId }) => ({
        url: START_AERIAL_RUN_URL,
        method: 'POST',
        body: {
          aerialId,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useStartAerialRunMutation } = startAerialRunApi;
